import { inject as service } from '@ember/service';
import Route from 'mewe/routes/route';
import ContactsApi from 'mewe/api/contacts-api';

export default Route.extend({
  theme: 'profile',

  router: service(),

  beforeModel(transition) {
    const id = transition.to.params.uuid;

    if (!id) this.router.transitionTo('error-404');

    return ContactsApi.getUserDetails({ userId: id })
      .then((res) => {
        if (res?.user?.publicLinkId) {
          this.router.transitionTo('app.publicid', res.user.publicLinkId);
        } else {
          this.router.transitionTo('error-404');
        }
      })
      .catch(() => {
        this.router.transitionTo('error-404');
      });
  },
});
